let userId: string | null = null;

/**
 * Retrieve the in-memory user ID.
 * @returns The user ID.
 */
export const getUserId = () => userId;

/**
 * Store the user ID.
 * @param newUserId User ID.
 */
export const setUserId = (newUserId: string) => {
    userId = newUserId;
};

/**
 * Clear the in-memory user ID.
 */
export const deleteUserId = () => {
    userId = null;
};
